import * as React from 'react';

interface IProps {
    headers: any[];
    loadLabel?: string;
    // The schedule of the runs that have only the loading column, which is the one the label is of, and no other metrics
    loadingOnly?: boolean;
}

export const MetricTableHeader = (props : IProps) => {

    // The runs with only the loading column need no bands over their columns: it is one row, the properties of the runs and
    // the loading column, which is coloured as its band is on the other schedule
    if (props.loadingOnly) {
        return (
            <thead>
                <tr className="schedule-sticky-top">
                    {
                        props.headers.map((itm: string, idx: number) =>
                            <th key={`dynamic-header-${idx}`}>{itm}</th>
                        )
                    }
                    <th className="schedule-header loading">{ props.loadLabel ?? 'LOAD' }</th>
                </tr>
            </thead>
        );
    }

    return (
        <thead>
            <tr className="schedule-sticky-top">
                {
                    props.headers.map((itm: string, idx: number) =>
                        <th key={`dynamic-header-top-${idx}`} className="border-free" />
                    )
                }
                <th className="schedule-header subassembly" colSpan={6}>SECTION SUBASSEMBLY</th>
                <th className="schedule-header print" colSpan={2}>PRINT</th>
                <th className="schedule-header windows" colSpan={5}>WINDOWS</th>
                <th className="schedule-header assembly" colSpan={8}>SECTION ASSEMBLY</th>
                <th className="schedule-header loading">{ props.loadLabel ?? 'LOAD' }</th>
                <th className="spacer-column" rowSpan={3} />
                <th className="schedule-header hw-subassembly" colSpan={7}>HARDWARE SUBASSEMBLY</th>
            </tr>
            <tr className="schedule-sticky-middle">
                {
                    props.headers.map((itm: string, idx: number) =>
                        <th key={`dynamic-header-bottom-${idx}`} className="border-free" />
                    )
                }
                {/* Section Subassembly */}
                <th colSpan={4}>2283</th>
                <th>RB</th>
                <th rowSpan={2} className="center-header" >FIP</th>
                {/* Print */}
                <th rowSpan={2} className="center-header">AW</th>
                <th rowSpan={2} className="center-header">AD</th>
                {/* Windows */}
                <th rowSpan={2} className="center-header">RP</th>
                <th rowSpan={2} className="center-header">83</th>
                <th rowSpan={2} className="center-header">FP</th>
                <th rowSpan={2} className="center-header">AP</th>
                <th rowSpan={2} className="center-header">RB</th>
                {/* Section Assembly */}
                <th rowSpan={2} className="center-header">RP</th>
                <th rowSpan={2} className="center-header">83</th>
                <th rowSpan={2} className="center-header">FP</th>
                <th rowSpan={2} className="center-header">AP</th>
                <th rowSpan={2} className="center-header">RB</th>
                <th rowSpan={2} className="center-header">FV</th>
                <th rowSpan={2} className="center-header">CH</th>
                <th rowSpan={2} className="center-header">I</th>
                <th rowSpan={2} />
                <th colSpan={3}>TRACK</th>
                <th colSpan={2}>SPRINGS</th>
                <th rowSpan={2} className="center-header">STRUTS</th>
                <th rowSpan={2} className="center-header">HDW</th>
            </tr>
            <tr className="schedule-sticky-bottom">
                {
                    props.headers.map((h: string, idx: number) =>
                        <th key={`dynamic-header-prop-${idx}`}>{h}</th>
                    )
                }
                {/* 2283 */}
                <th>W</th>
                <th>OW</th>
                <th>OD</th>
                <th>90</th>
                {/* Rib */}
                <th>W</th>
                {/* Track */}
                <th>RES</th>
                <th>COMM</th>
                <th>LHR</th>
                {/* Springs */}
                <th>RES</th>
                <th>COMM</th>
            </tr>
        </thead>
    )

}